// extracted by mini-css-extract-plugin
export default {"cls1":"SocialEditor-cls1_Ybo","cls2":"SocialEditor-cls2_zwL SocialEditor-cls1_Ybo"};